import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class NuSVRGraph extends AbstractScatterVisualization {
}
